// // GenericScreen.jsx — one question at a time, full scored option support
// import React, { useMemo, useRef, useState, useEffect } from 'react';
// import styles from '../../styles/assessments.module.css';

// import {
//   ScreenHeader, ProgressBar, ScreenFooter,
//   ToggleGroup, Slider,
//    MultiChipSelect,
//   IconOptionGroup, EmojiGroup, QOLGroup,
//   RedFlagAlert, AgeChips, NumberInput, ThreeOptionGroup,
// } from './SharedUI';
// import { useNavigate } from 'react-router-dom';

// // ─── helpers ─────────────────────────────────────────────
// const inchesToFeet = (inches) => `${Math.floor(inches / 12)}'${inches % 12}"`;

// const getSliderFormatter = (q) => {
//   if (q.displayFormat === 'feet') return inchesToFeet;
//   if (typeof q.formatValue === 'function') return q.formatValue;
//   return undefined;
// };

// // ─── component ───────────────────────────────────────────
// const GenericScreen = ({
//   screenConfig, data, onChange,
//   onNext, onBack, onExit,
//   step, totalSteps, nextLabel = 'Next',
//   customFooter,
//   openLastQuestion
// }) => {
//   console.log(screenConfig,"thiss in the genric screen")
//   const scrollRef = useRef(null);
//   const dateRef = useRef(null);
//   const today = new Date().toISOString().split('T')[0];
// const navigate = useNavigate();
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

//   // ── conditional visibility ──
//   const isVisible = (q) => {
//     if (!q.conditional) return true;
//     const { field, value, notValue, includes, notIncludes } = q.conditional;
//     const fv = data[field];
//     if (value !== undefined) return fv === value;
//     if (notValue !== undefined) return fv !== notValue;
//     if (includes !== undefined) return Array.isArray(fv) ? fv.includes(includes) : false;
//     if (notIncludes !== undefined) return Array.isArray(fv) ? !fv.includes(notIncludes) : true;
//     return true;
//   };

//   const visibleQuestions = useMemo(
//     () => (screenConfig.questions?.filter(isVisible) || []),
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [screenConfig.questions, data],
//   );

//   const currentQuestion = visibleQuestions[currentQuestionIndex];
//   const isLastQuestion = currentQuestionIndex === visibleQuestions.length - 1;

//   // red flag
//   const anyRedFlagTriggered = screenConfig.questions
//     ?.filter((q) => q.redFlag)
//     .some((q) => data[q.id] === 'Yes');

//   // reset index when visible set shrinks
//   useEffect(() => {
//     if (currentQuestionIndex > visibleQuestions.length - 1) {
//       setCurrentQuestionIndex(0);
//     }
//   }, [visibleQuestions, currentQuestionIndex]);

//   // ── navigation ──
//   const scrollTop = () => scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });

//   const handleNextQuestion = () => {
//     if (!isLastQuestion) { setCurrentQuestionIndex((p) => p + 1); scrollTop(); return; }
//     onNext?.();
//   };
//   const handlePrevQuestion = () => {
//     if (currentQuestionIndex > 0) {
//       setCurrentQuestionIndex((p) => p - 1); scrollTop(); return;

//     }
//     onBack?.();
//   };

//   useEffect(() => {
//   if (openLastQuestion) {
//     setCurrentQuestionIndex(
//       Math.max(visibleQuestions.length - 1, 0)
//     );
//   } else {
//     setCurrentQuestionIndex(0);
//   }
// }, [openLastQuestion, visibleQuestions.length]);
//   // ── render one question ──
//   const renderQuestion = (q) => {
//     console.log(q,"tisis q")
//     if (!q) return null;
//     const val = data?.[q.id];
//     console.log(val,"this is the va")
//     // normalise options: always an array of objects
//     const opts = (q.options || []).map((o) =>
//       typeof o === 'object' ? o : { id: o, label: o, score: 0 }
//     );

//     return (
//       <div key={q.id} className={styles.questionBlock}>
//         {/* counter */}
//         {/* <div className={styles.questionCounter}>
//           Question {currentQuestionIndex + 1} of {visibleQuestions.length}
//         </div> */}

//         {/* label */}
//         <label className={styles.questionLabel}>{q.label}</label>

//         {/* description */}
//         {q.description && <p className={styles.questionDescription}>{q.description}</p>}

//         {/* ── input types ── */}
//         {q.type === 'toggle' && (
//           <ToggleGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
//         )}

//         {q.type === 'ageChips' && (
//           <AgeChips options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
//         )}

//         {q.type === 'date' && (
//           <div className={styles.dateInput}>
//             <input
//               ref={dateRef} className={styles.input}
//               type="date" max={today} value={val || ''}
//               onChange={(e) => onChange(q.id, e.target.value)}
//             />
//           </div>
//         )}

//         {q.type === 'slider' && (
//           <Slider
//             value={val ?? q.defaultValue ?? q.min ?? 0}
//             onChange={(v) => onChange(q.id, v)}
//             min={q.min ?? 0} max={q.max ?? 10} step={q.step ?? 1}
//             unit={q.unit}
//             leftLabel={q.leftLabel || 'Low'}
//             rightLabel={q.rightLabel || 'High'}
//             formatValue={getSliderFormatter(q)}
//           />
//         )}

//         {q.type === 'iconOption' && (
//           <IconOptionGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
//         )}

//         {q.type === 'emoji' && (
//           <EmojiGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
//         )}

//         {q.type === 'qol' && (
//           <QOLGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
//         )}

//         {q.type === 'multiChip' && (
//           <MultiChipSelect
//             options={opts} selected={val || []}
//             onChange={(v) => onChange(q.id, v)}
//             noneValue={q.noneValue}
//           />
//         )}

//         {q.type === 'text' && (
//           <input
//             className={styles.input} type="text"
//             value={val || ''} placeholder={q.placeholder || ''}
//             onChange={(e) => onChange(q.id, e.target.value)}
//           />
//         )}

//         {q.type === 'numberInput' && (
//           <NumberInput
//             value={val} onChange={(v) => onChange(q.id, v)}
//             placeholder={q.placeholder} unit={q.unit}
//           />
//         )}

//         {q.type === 'threeOption' && (
//           <ThreeOptionGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
//         )}

//         {/* inline red-flag warning */}
//         {/* {q.redFlag && val === 'Yes' && (
//           <div className={styles.inlineRedFlag}>
//             ⚠️ This requires immediate medical attention. Please contact a doctor.
//           </div>
//         )} */}
//         {q.redFlag && val === 'Yes' && (
//   <div className={styles.inlineRedFlag}>
//     <p>⚠️ This requires immediate medical attention. Please contact a doctor.</p>

//     <button
//       type="button"
//       className={styles.bookAppointmentBtn}
//       onClick={() => navigate('/book-appointment')}
//     >
//       Book an Appointment
//     </button>
//   </div>
// )}
//       </div>
//     );
//   };

//   return (
//     <div className={styles.screenWrap}>
//       <ScreenHeader onExit={onExit} />
//       {/* this one is for steps */}
//       {/* <ProgressBar step={step} total={totalSteps} /> */}
//       {totalSteps>1&&(


//       <p className={styles.stepText}>Steps {step} of {totalSteps}
//       </p> )}
//       {/* sfsdf */}

//       <ProgressBar
//         step={currentQuestionIndex + 1}
//         total={visibleQuestions.length}
//       />

//       <div className={`${styles.screenBody} ${styles.scrollBody}`} ref={scrollRef}>
//         {/* title */}
//         {screenConfig.icon ? (
//           <div className={styles.screenTitleRow}>
//             <h2 className={styles.screenTitle}>{screenConfig.title}</h2>
//             <div className={styles.screenIconBox}>
//               <span style={{ fontSize: 22 }}>{screenConfig.icon}</span>
//             </div>
//           </div>
//         ) : (
//           <h2 className={styles.screenTitle}>{screenConfig.title}</h2>
//         )}

//         {/* subtitle */}
//         <p className={styles.screenSubtitle}>{screenConfig.subtitle}</p>

//         {/* red-flag intro banner */}
//         {screenConfig?.isRedFlag && (
//           <div className={`${styles.dangerSignAlert} ${styles.dangerSignAlertMb}`}>
//             <p className={styles.dangerSignTitle}>⚠️ Important Warning</p>
//             <p className={styles.dangerSignText}>
//               If you answer "Yes" to any of the following questions, please seek immediate medical attention.
//             </p>
//           </div>
//         )}

//         {/* ONE question at a time */}
//         {renderQuestion(currentQuestion)}

//         {/* global red-flag alert */}
//         {anyRedFlagTriggered && <RedFlagAlert />}
//       </div>

//       {customFooter ? customFooter : (
//         <ScreenFooter
//           onBack={handlePrevQuestion}
//           onNext={handleNextQuestion}
//           nextLabel={isLastQuestion ? nextLabel : 'Continue'}
//         />
//       )}
//     </div>
//   );
// };

// export default GenericScreen;
// GenericScreen.jsx — one question at a time, with optional group rendering
import React, { useMemo, useRef, useState, useEffect } from 'react';
import styles from '../../styles/assessments.module.css';

import {
  ScreenHeader, ProgressBar, ScreenFooter,
  ToggleGroup, Slider, MultiChipSelect,
  IconOptionGroup, EmojiGroup, QOLGroup,
  RedFlagAlert, AgeChips, NumberInput, ThreeOptionGroup,
} from './SharedUI';
import { useNavigate } from 'react-router-dom';

// ─── helpers ─────────────────────────────────────────────
const inchesToFeet = (inches) => `${Math.floor(inches / 12)}'${inches % 12}"`;

const getSliderFormatter = (q) => {
  if (q.displayFormat === 'feet') return inchesToFeet;
  if (typeof q.formatValue === 'function') return q.formatValue;
  return undefined;
};

// ─── collapse flat questions into steps ──────────────────
// A "step" is either:
//   { type: 'single', question: q }           — one question shown alone
//   { type: 'group',  groupId, questions: [] } — multiple shown together
const buildSteps = (questions) => {
  const steps = [];
  const seenGroups = new Set();

  for (const q of questions) {
    if (q.group) {
      if (!seenGroups.has(q.group)) {
        seenGroups.add(q.group);
        // collect ALL questions with this group id
        const groupQs = questions.filter((gq) => gq.group === q.group);
        steps.push({ type: 'group', groupId: q.group, questions: groupQs });
      }
      // subsequent questions with the same group are already in the step above
    } else {
      steps.push({ type: 'single', question: q });
    }
  }
  return steps;
};

// ─── component ───────────────────────────────────────────
const GenericScreen = ({
  screenConfig, data, onChange,
  onNext, onBack, onExit,
  step, totalSteps, nextLabel = 'Next',
  customFooter,
  openLastQuestion,
  initialStepIndex,
}) => {
  const scrollRef = useRef(null);
  const dateRef = useRef(null);
  const today = new Date().toISOString().split('T')[0];
  const navigate = useNavigate();

  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  // ── conditional visibility ──────────────────────────────
  const isVisible = (q) => {
    if (!q.conditional) return true;
    const { field, value, notValue, includes, notIncludes } = q.conditional;
    const fv = data[field];
    if (value !== undefined) return fv === value;
    if (notValue !== undefined) return fv !== notValue;
    if (includes !== undefined) return Array.isArray(fv) ? fv.includes(includes) : false;
    if (notIncludes !== undefined) return Array.isArray(fv) ? !fv.includes(notIncludes) : true;
    return true;
  };
  
  // GenericScreen.jsx — only change this one useEffect


  // ── build visible steps (respects conditional + grouping) ─
  const visibleSteps = useMemo(() => {
    const visibleQs = (screenConfig.questions || []).filter(isVisible);
    return buildSteps(visibleQs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenConfig.questions, data]);

  const currentStep = visibleSteps[currentStepIndex];
  const isLastStep = currentStepIndex === visibleSteps.length - 1;

  // red flag check across ALL questions
  const anyRedFlagTriggered = screenConfig.questions
    ?.filter((q) => q.redFlag)
    .some((q) => data[q.id] === 'Yes');

  // clamp index if visible set shrinks
  useEffect(() => {
    if (currentStepIndex > visibleSteps.length - 1) {
      setCurrentStepIndex(0);
    }
  }, [visibleSteps, currentStepIndex]);

  // // openLastQuestion support
  // useEffect(() => {
  //   if (openLastQuestion) {
  //     setCurrentStepIndex(Math.max(visibleSteps.length - 1, 0));
  //   } else {
  //     setCurrentStepIndex(0);
  //   }
  // }, [openLastQuestion, visibleSteps.length]);
  useEffect(() => {
    if (initialStepIndex !== null && initialStepIndex !== undefined) {
      setCurrentStepIndex(
        Math.min(initialStepIndex, visibleSteps.length - 1)
      );
    } else if (openLastQuestion) {
      setCurrentStepIndex(Math.max(visibleSteps.length - 1, 0));
    } else {
      setCurrentStepIndex(0);
    }
  }, [openLastQuestion, initialStepIndex, visibleSteps.length])
  // ── navigation ──────────────────────────────────────────
  const scrollTop = () => scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });

  const handleNextStep = () => {
    if (!isLastStep) { setCurrentStepIndex((p) => p + 1); scrollTop(); return; }
    onNext?.();
  };

  const handlePrevStep = () => {
    if (currentStepIndex > 0) { setCurrentStepIndex((p) => p - 1); scrollTop(); return; }
    onBack?.();
  };

  // ── render a single question input ─────────────────────
  const renderQuestionInput = (q) => {
    if (!q) return null;
    const val = data?.[q.id];
    // const val = data?.[q.id]?.value; 
    const opts = (q.options || []).map((o) =>
      typeof o === 'object' ? o : { id: o, label: o, score: 0 }
    );

      const getScore = (selectedValue) => {
        console.log(selectedValue,"this is the selectedvalue")
    const found = opts.find((o) => o.label === selectedValue);
    console.log(opts,"these r options")
    console.log(found,"this is found")
    return found?.score ?? 0;
  };
    return (
      <div key={q.id} className={styles.questionBlock}>
        <label className={styles.questionLabel}>{q.label}</label>

        {q.description && <p className={styles.questionDescription}>{q.description}</p>}

        {q.type === 'toggle' && (
          <ToggleGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
        )}
        {q.type === 'ageChips' && (
          <AgeChips options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
        )}
        {q.type === 'date' && (
          <div className={styles.dateInput}>
            <input
              ref={dateRef} className={styles.input}
              type="date" max={today} value={val || ''}
              onChange={(e) => onChange(q.id, e.target.value)}
            />
          </div>
        )}
        {q.type === 'slider' && (
          <Slider
            value={val ?? q.defaultValue ?? q.min ?? 0}
            onChange={(v) => onChange(q.id, v)}
            min={q.min ?? 0} max={q.max ?? 10} step={q.step ?? 1}
            unit={q.unit}
            leftLabel={q.leftLabel || 'Low'}
            rightLabel={q.rightLabel || 'High'}
            formatValue={getSliderFormatter(q)}
          />
        )}
        {q.type === 'iconOption' && (
          <IconOptionGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
        )}
        {q.type === 'emoji' && (
          <EmojiGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
        )}
        {q.type === 'qol' && (
          <QOLGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
        )}
        {q.type === 'multiChip' && (
          <MultiChipSelect
            options={opts} selected={val || []}
            onChange={(v) => onChange(q.id, v)}
            noneValue={q.noneValue}
          />
        )}
        {q.type === 'text' && (
          <input
            className={styles.input} type="text"
            value={val || ''} placeholder={q.placeholder || ''}
            onChange={(e) => onChange(q.id, e.target.value)}
          />
        )}
        {q.type === 'numberInput' && (
          <NumberInput
            value={val} onChange={(v) => onChange(q.id, v)}
            placeholder={q.placeholder} unit={q.unit}
          />
        )}
        {q.type === 'threeOption' && (
          <ThreeOptionGroup options={opts} value={val} onChange={(v) => onChange(q.id, v)} />
        )}

        {q.redFlag && val === 'Yes' && (
          <div className={styles.inlineRedFlag}>
            <p>⚠️ This requires immediate medical attention. Please contact a doctor.</p>
            <button
              type="button"
              className={styles.bookAppointmentBtn}
              onClick={() => navigate('/book-appointment')}
            >
              Book An Appointment
            </button>
          </div>
        )}
      </div>
    );
  };

  // ── render the current step (single OR group) ───────────
  const renderCurrentStep = () => {
    if (!currentStep) return null;

    if (currentStep.type === 'single') {
      return renderQuestionInput(currentStep.question);
    }

    // group: render all questions in the group one after another
    if (currentStep.type === 'group') {
      return (
        <div className={styles.questionGroupBlock}>
          {currentStep.questions.map((q) => renderQuestionInput(q))}
        </div>
      );
    }
  };

  // ── render ──────────────────────────────────────────────
  return (
    <div className={styles.screenWrap}>
      <ScreenHeader onExit={onExit} />

      {totalSteps > 1 && (
        <p className={styles.stepText}>Steps {step} of {totalSteps}</p>
      )}

      <ProgressBar
        step={currentStepIndex + 1}
        total={visibleSteps.length}
      />

      <div className={`${styles.screenBody} ${styles.scrollBody}`} ref={scrollRef}>
        {screenConfig.icon ? (
          <div className={styles.screenTitleRow}>
            <h2 className={styles.screenTitle}>{screenConfig.title}</h2>
            <div className={styles.screenIconBox}>
              <span style={{ fontSize: 22 }}>{screenConfig.icon}</span>
            </div>
          </div>
        ) : (
          <h2 className={styles.screenTitle}>{screenConfig.title}</h2>
        )}

        <p className={styles.screenSubtitle}>{screenConfig.subtitle}</p>

        {screenConfig?.isRedFlag && (
          <div className={`${styles.dangerSignAlert} ${styles.dangerSignAlertMb}`}>
            <p className={styles.dangerSignTitle}>⚠️ Important Warning</p>
            <p className={styles.dangerSignText}>
              If you answer "Yes" to any of the following questions, please seek immediate medical attention.
            </p>
          </div>
        )}

        {renderCurrentStep()}

        {anyRedFlagTriggered && <RedFlagAlert />}
      </div>

      {customFooter ? customFooter : (
        <ScreenFooter
          onBack={handlePrevStep}
          onNext={handleNextStep}
          nextLabel={isLastStep ? nextLabel : 'Continue'}
        />
      )}
    </div>
  );
};

export default GenericScreen;
